import { createSelector } from 'reselect';

export const makeSortQuickReply = () =>
  createSelector([reply => reply], reply => {
    if (!reply || reply.length === 0) {
      return [];
    }
    reply = reply.sort((a, b) => a.rank - b.rank);
    return reply.map(val => {
      const { quick_replies } = val;
      if (quick_replies && quick_replies.length) {
        val.quick_replies = quick_replies.sort((a, b) => a.rank - b.rank);
      }
      return val;
    });
  });
